<div id="d3-container">
  <svg id="d3-svg" style="display: block; margin: auto" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <marker id="arrow" viewBox="0 0 10 10" refX="53" refY="5"
          markerWidth="6" markerHeight="6"
          orient="auto-start-reverse">
        <path d="M 0 0 L 10 5 L 0 10 z"></path>
      </marker>
    </defs>
  </svg>
  <div id="d3-tooltip"><pre style="margin:0"></pre></div>
</div>